import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {autocompleteEvkOption, EvkFormComponentBase, EvkHttpService, EvkOption} from '@evomatik/evk-common';
import {CatalogosService} from "../../../../../../../expediente/services/catalogos.service";
import {tap} from "rxjs/operators";


@Component({
    selector: 'turnar-dilgencia-form',
    templateUrl: './diligencia-turnar-form.component.html',
    styleUrls: ['./diligencia-turnar-form.component.scss']
})
export class TurnarDiligenciaFormComponent extends EvkFormComponentBase<any> implements OnInit {

    tipoOrganizacion$: Observable<EvkOption[]>;
    unidadOptions$: Observable<EvkOption[]>;
    unidadOptions: EvkOption[];
    usuarioReceptorOptions$: Observable<EvkOption[]>;

    unidadFilter$: Observable<EvkOption[]>;
    usuarioFilter$: Observable<EvkOption[]>;
    tipoOrganizacionFilter$: Observable<EvkOption[]>;


    public asignarResponsable = false;
    public multipleTurnado = false;

    public idConfig: string | number;

    constructor(
        fb: FormBuilder,
        public catalogoService: CatalogosService,
        public http: EvkHttpService
    ) {
        super(fb);
    }

    get formBuild() {
        return this.fb.group({
            tipoOrganizacion: ['', [Validators.required, autocompleteEvkOption]],
            organizacion: ['', [Validators.required, autocompleteEvkOption]],
            usuarioAsignado: ['', [autocompleteEvkOption]],
        });
    }

    /**
     * Metodo de consulta y carga de las opciones iniciales básicas
     */
    public getCatalogos() {
        /**  Fetch de las opciones iniciales y subscripcion para mostrar las opciones sin escribir en el autocomplete */
        this.tipoOrganizacion$ = this.multipleTurnado ?
            this.catalogoService.getTipoOrganizacionTurnadoByIdOrganizacionAndTipo('TURNADO', this.idConfig) :
            this.catalogoService.getTipoOrganizacionTurnadoByIdDiligenciaConfig(this.idConfig);
        this.getFiltrios();
    }

    getFiltrios() {
        this.tipoOrganizacionFilter$ = this.filterOptions(this.form.controls['tipoOrganizacion'], this.tipoOrganizacion$);
    }


    ngOnInit() {
        super.ngOnInit();
        //    this.getCatalogos();
    }

    onTipoOrganizacionSelected(event: any) {
        this.resetChildOptionsFromOrganizacion();
        const idTipo = event.option.value.value;

        this.unidadOptions$ = this.catalogoService.getOrganizacionByTipo(idTipo);
        this.unidadFilter$ = this.filterOptions(this.form.controls['organizacion'], this.unidadOptions$);
    }

    /**
     * Metodo de soporte del evento ON al selccionar/modificar una opción
     * @param event
     */
    onUnidadSelected(event: any) {
        this.http.get(`/seaged-administrador-service/organizacion/${event.option.value.value}`).subscribe(({data}) => {
            this.asignarResponsable = data['asignarresponsable'];
        });
        const evkOption: EvkOption = event.option.value;
        this.loadUsuariosFromUnidad(evkOption);
    }

    resetChildOptionsFromOrganizacion() {
        this.form.controls.organizacion.setValue('');
        this.form.controls.usuarioAsignado.setValue('');
    }

    loadUsuariosFromUnidad(unidad: EvkOption) {
        const username = sessionStorage.getItem('username');
        this.usuarioReceptorOptions$ = this.catalogoService.getUsuariosForUnidadOrganizacionalLogica(unidad.value, ['RECEPTOR_TAREA'], username).pipe(tap(val => console.log(val)));
        this.usuarioFilter$ = this.filterOptions(this.form.controls['usuarioAsignado'], this.usuarioReceptorOptions$);
    }
}
